import { typographyV2 } from '@toggle/design-system';
import styled, { keyframes } from 'styled-components';

import { getHeaderAnimation } from '~/modules/asset-overview-header/utils';

import { ThemeLogoIcon } from '../theme-logo-icon/ThemeLogoIcon';

const iconShrink = keyframes`
  from {
    height: 48px;
    width: 48px;
  }
  to {
    height: 20px;
    width: 20px;
  }
`;

const iconExpand = keyframes`
  from {
    height: 20px;
    width: 20px;
  }
  to {
    height: 48px;
    width: 48px;
  }
`;

export const LogoAndTitleWrapper = styled.div<{ $isCondensed: boolean }>`
  display: flex;
  gap: 8px;
  align-items: center;
  ${ThemeLogoIcon.Styled.StyledLogoImg},
  ${ThemeLogoIcon.Styled.LogoFallback} {
    ${({ $isCondensed }) =>
      getHeaderAnimation({
        isCondensed: $isCondensed,
        expandAnimation: iconExpand,
        shrinkAnimation: iconShrink,
      })}
  }
`;

export const FlexRowWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  justify-content: space-between;
  gap: 8px;
`;

export const TitleText = styled.div<{ $isCondensed: boolean }>`
  ${({ $isCondensed }) =>
    $isCondensed ? typographyV2.bodySm : typographyV2.bodyMd};
  text-transform: capitalize;
`;
